import { FieldInputProps, useFormikContext } from "formik";
import React from "react";

import { FieldStateProps } from "../FieldHeader";
import { TextField } from "../TextField";

type PriceInputFieldProps = Readonly<{
  name: string;
  title: string;
  type?: "number" | "string";
  isRequiredField?: boolean;
}> &
  FieldStateProps;

export const PriceInputField = (props: PriceInputFieldProps) => {
  const { name, title, type, isSaving, isRequiredField } = props;
  const { setFieldValue } = useFormikContext();

  const priceAcceptedValuesOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    const sanitizedValue = e.target.value.replace(/[^0-9.]/g, "");
    const inputValue = sanitizedValue.match(/^(?:[0-9]{1,6}(?:\.[0-9]{0,2})?)?/)?.[0] ?? "";
    setFieldValue(field.name, inputValue);
    return field.onChange;
  };

  const priceFormatOnBlur = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    const targetValue = e.target.value.replace(/[$,]/g, "");
    if (!targetValue) {
      return field.onBlur(e);
    }

    setFieldValue(
      field.name,
      Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(parseFloat(targetValue))
    );
    return field.onBlur(e);
  };

  return (
    <TextField
      name={name}
      title={title}
      type={type}
      isRequiredField={isRequiredField}
      isSaving={isSaving}
      customOnChange={priceAcceptedValuesOnChange}
      customOnBlur={priceFormatOnBlur}
    />
  );
};
